<template>
    <div>
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex lg4 pr-6 pl-6>
                    <v-layout row wrap justify-end>
                        <v-menu v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y
                            max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="computedStartDateFormatted" label="Từ ngày" hint="DD-MM-YYYY"
                                    persistent-hint prepend-icon="fa-calendar-alt" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title
                                @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y
                            max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="computedEndDateFormatted" label="Đến ngày" hint="DD-MM-YYYY"
                                    persistent-hint prepend-icon="fa-calendar-alt" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 pr-6>
                    <v-btn @click="filter_data" color="#a77800" outlined>Xem</v-btn>
                </v-flex>
                <v-flex lg12>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :items="items" :headers="headers" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.ReportDate | display_date('DD-MM-YYYY') }}</td>
                                <td class="text-end">{{ item.AmountRMB | currency('',2) }}</td>
                                <td class="text-end">{{ item.ExchangeRate | currency }}</td>
                                <td class="text-end">{{ item.AmountVND | currency }}</td>
                                <td>{{ item.BankName }}</td>
                                <td >{{ item.Note }}</td>
                                <td class="text-center">
                                    <v-icon :disabled="!(adminRole || paymentRole)" medium class="mr-2" @click="openDetail(item)">fa-edit</v-icon>
                                    <v-icon :disabled="!(adminRole || paymentRole)" medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:body.append v-if="summary">
                            <tr class="total-summary-td">
                                <td class="font-weight-bold">TỔNG</td>
                                <td class="text-end font-weight-bold">{{ summary.AmountRMB | currency('', 2) }}</td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold">{{ summary.AmountVND | currency }}</td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold"></td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="dialogUpdate" persistent max-width="700px">
            <v-card>
                <v-card-title>
                    <span class="title">Chi tiền mua RMB</span>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap pa-3>
                        <v-flex lg12 md12 sm12>
                            <mh-date-picker plabel="Ngày mua" class="input-group--focused date-picker px-3" v-model="report_date" @onChangeDate="report_date =$event"></mh-date-picker>
                        </v-flex>
                        <v-flex lg12 md12 sm12>
                            <h-currency-input v-model="currentItem.AmountRMB" :decimal="2" label="Số tiền RMB" class="input-group--focused"></h-currency-input>
                        </v-flex>
                        <v-flex lg12 md12 sm12>
                            <h-currency-input v-model="currentItem.ExchangeRate" :decimal="0" label="Tỷ giá" class="input-group--focused"></h-currency-input>
                        </v-flex>
                        <v-flex lg12 md12 sm12>
                            <h-currency-input v-model="currentItem.AmountRMB" :decimal="2" label="Số tiền RMB" class="input-group--focused"></h-currency-input>
                        </v-flex>
                        <v-flex lg12 md12 sm12>
                            <v-select label="Số tài khoản" class="input-group--focused" :items="config_banks" v-model="currentItem.Bank" item-text="name" item-value="value"></v-select>
                        </v-flex>
                        <v-flex lg12 md12 sm12>
                            <v-text-field v-model="currentItem.Note" label="Ghi chú" class="input-group--focused"></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" dark @click="dialogUpdate = false">Đóng</v-btn>
                    <v-btn color="blue darken-1" dark @click="saveItem(currentItem)">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment";
import Filtering from "@/components/Filtering";
import MHDatePicker from "@/components/daterange/MHDatePicker";
export default {
    components: {
        "hpo-filter": Filtering,
        "mh-date-picker": MHDatePicker
    },
    data() {
        return {
            dialogUpdate: false,
            headers: [
                {
                    text: "Ngày",
                    value: "ReportDate",
                    filterable: true,
                    width: 120,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Số tiền RMB",
                    value: "AmountRMB",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tỷ giá",
                    value: "ExchangeRate",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Số tiền VND",
                    value: "AmountVND",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Số tài khoản",
                    value: "Bank",
                    filterable: true,
                    values: this.config_banks,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Ghi chú",
                    value: "Note",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "",
                    width: 100
                }
            ],
            viewName: "bao-cao-chi-tien-mua-rmb",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            pagination: {...configs.PAGINATION, sortBy: ["ReportDate"], sortDesc: [true]},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            filterConditions: [],
            quickFilterConditions: [],
            currentItem: {},
            report_date: null,
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.reportRMB.all.data,
            summary: state => state.reportRMB.all.summary,
            total_rows: state => state.reportRMB.all.total,
            loading: state => state.reportRMB.loading,
            configuration: state => state.configuration.selected,
        }),
        computedStartDateFormatted() {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted() {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        paymentRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.InteralControl) == configs.ROLE_TYPE.InteralControl;
        },
        config_banks() {
            return this.configuration.ReExBanks ? JSON.parse(this.configuration.ReExBanks) : [];
        },
    },
    methods: {
        applyFilter(filterConditions) {
            this.pagination = {
                ...configs.PAGINATION,
                sortBy: this.pagination.sortBy,
                sortDesc: this.pagination.sortDesc
            };
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: [...this.filterConditions],
                quickFilter: this.quickFilterConditions
            };
            param.filter = _.filter(param.filter, p => {return p.column != 'ReportDate'});
            param.filter.push({ column: "ReportDate", value: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT), condition: "d_greater_than_or_equal"});
            param.filter.push({ column: "ReportDate", value: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT), condition: "d_less_than_or_equal"});
            this.$store.dispatch("reportRMB/getList", param);
            this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.adminRole || this.paymentRole)});
        },
        openDetail(item) {
            this.dialogUpdate = true;
            this.currentItem = item;
            this.report_date = this.currentItem.ReportDate ? moment(this.currentItem.ReportDate).toISOString().substr(0, 10) : null;
        },
        deleteItem(id) {
            window.getApp.$emit("REQUEST_DELETE_DATA", id);
        },
        saveItem(item) {
            const bank = _.find(this.config_banks, {'value': item.Bank})
            this.$store.dispatch("reportRMB/setDetail", {
                id: item.ID,
                data: {
                    ...item,
                    BankName: bank ? bank.name : '',
                    AmountVND: item.AmountRMB * item.ExchangeRate,
                    ReportDate: this.report_date ? moment(this.report_date, 'YYYY-MM-DD').format(configs.SQL_DATE_FORMAT) : null,
                }
            });
            this.dialogUpdate = false;
        },
        createData() {
            this.currentItem = {
                ID: 0,
                AmountRMB: 0,
                ExchangeRate: 0,
                AmountVND: 0
            };
            this.dialogUpdate = true;
        },
    },
    mounted() {
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.adminRole || this.paymentRole)});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("reportRMB/removeDetail", id);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>